import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Gear16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_337)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 4.75C6.20507 4.75 4.75 6.20507 4.75 8C4.75 9.79493 6.20507 11.25 8 11.25C9.79493 11.25 11.25 9.79493 11.25 8C11.25 6.20507 9.79493 4.75 8 4.75ZM6.25 8C6.25 7.0335 7.0335 6.25 8 6.25C8.9665 6.25 9.75 7.0335 9.75 8C9.75 8.9665 8.9665 9.75 8 9.75C7.0335 9.75 6.25 8.9665 6.25 8Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2858 0.964085C10.2858 0.431635 9.85415 0 9.3217 0H6.67844C6.146 0 5.71436 0.431635 5.71436 0.964084L5.71436 1.30157C5.71436 2.69038 4.17147 3.52328 3.01039 2.76127C2.60936 2.49807 2.0711 2.60775 1.80502 3.00687L0.554775 4.88224C0.248422 5.34176 0.372596 5.96263 0.832125 6.26899C2.11144 7.12187 2.08534 8.89554 0.832125 9.73101C0.372596 10.0374 0.248422 10.6582 0.554775 11.1178L1.80327 12.9905C2.06976 13.3902 2.60984 13.4983 3.00957 13.2318C4.16573 12.461 5.71436 13.2898 5.71436 14.6793L5.71436 15.035C5.71436 15.5679 6.14642 16 6.6794 16H9.32075C9.85373 16 10.2858 15.5679 10.2858 15.035V14.6793C10.2858 13.2898 11.8344 12.461 12.9906 13.2318C13.3903 13.4983 13.9304 13.3902 14.1969 12.9905L15.4454 11.1178C15.7517 10.6582 15.6276 10.0374 15.168 9.73101C13.8887 8.87813 13.9148 7.10446 15.168 6.26899C15.6276 5.96263 15.7517 5.34176 15.4454 4.88224L14.1951 3.00687C13.929 2.60775 13.3908 2.49807 12.9898 2.76127C11.8287 3.52328 10.2858 2.69038 10.2858 1.30158V0.964085ZM2.7398 4.30886C4.74586 5.14247 7.07849 3.7511 7.20865 1.5H8.7915C8.92166 3.7511 11.2543 5.14247 13.2603 4.30886L13.931 5.31478C12.2591 6.70364 12.2591 9.29636 13.931 10.6852L13.2655 11.6834C11.257 10.8377 8.90876 12.235 8.79045 14.5H7.2097C7.09139 12.235 4.74312 10.8377 2.73463 11.6834L2.06919 10.6852C3.74106 9.29636 3.74106 6.70365 2.06919 5.31478L2.7398 4.30886Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_337'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Gear16.displayName = 'Gear16';
export default Gear16;
